export function getdata() {
	let obj = {
		searchlist: [{
				prop: "ref10",
				label: 'File Type',
				type: "input",
			},
			{
				prop: "pingzh",
				label: 'Document Number',
				type: "input",
			}, {
				prop: "pingzrq",
				label: 'Document Date',
				type: "date",
				valueformat: 'yyyy-MM-dd'
			}, {
				prop: "yuanpzzy2",
				label: 'Assignment',
				type: "input",
			}, {
				prop: "guozrq",
				label: 'Posting Date',
				type: "date",
				valueformat: 'yyyy-MM-dd'
			}, {
				prop: "pingzlx",
				label: 'Document type',
				type: "select",
				selectval: [],
			},
		],
		searchdata: {
			ref10: '',
			pingzh: '',
			pingzrq: [],
			yuanpzzy2: '',
			guozrq: [],
			pingzlx: '',
		},
		headData: [{
				title: "File Type",
				prop: "ref10",
				width: "140",
				issort: true,
			},
			{
				title: "Assignment",
				prop: "yuanpzzy2",
				width: "140",
				issort: true,
			},
			{
				title: "Document Number",
				prop: "pingzh",
				width: "160",
				issort: true,
			},
			{
				title: "Document type",
				prop: "pingzlx",
				width: "150",
				issort: true,
			},
			{
				title: "Documet Date",
				prop: "pingzrq",
				width: "150",
				issort: true,
			},
			{
				title: "Posting Date",
				prop: "guozrq",
				width: "160",
				issort: true,
			},
			{
				title: "Document currency",
				prop: "yuanbz",
				width: "160",
				issort: true,
			}, {
				title: "Amount in doc. curr.",
				prop: "yuanbje",
				width: "170",
				issort: true,
			}, {
				title: "Local Currency",
				prop: "benb",
				width: "160",
				issort: true,
			}, {
				title: "Amount in local currency",
				prop: "benbje",
				width: "200",
				issort: true,
			}, {
				title: "Local currency 2",
				prop: "localCurrency2",
				width: "160",
				issort: true,
			},
			{
				title: "Amount in loc.curr.2",
				prop: "localCurrency2Amount",
				width: "160"
			},
			{
				title: "Tax Code",
				prop: "ref5 ",
				width: "140",
				issort: true,
			},
			{
				title: "Cost Center",
				prop: "ref1",
				width: "140"
			},
			{
				title: "Clearing Document",
				prop: "ref6",
				width: "160",
				issort: true,
			},
			{
				title: "Clearing date",
				prop: "ref8",
				width: "140",
				issort: true,
			},
			{
				title: "G/L Account",
				prop: "erpkm",
				width: "120",
				issort: true,
			},
			{
				title: "Profit Center",
				prop: "ref7",
				width: "120",
				issort: true,
			},
			{
				title: "Text",
				prop: "yuanpzzy1",
				width: "120",
				issort: true,
			},
			{
				title: "Entry Date",
				prop: "gengxsj",
				width: "120",
				issort: true,
			},
			{
				title: "User Name",
				prop: "zhidr",
				width: "120",
				issort: true,
			},
			{
				title: "Reference",
				prop: "ref9",
				width: "120",
				issort: true,
			},
			{
				title: "Fiscal Year",
				prop: "cain",
				width: "120",
				issort: true,
			},
			{
				title: "Posting Period",
				prop: "qij",
				width: "140",
				issort: true,
			},

		],
		pagination: {
			pageNum: 1,
			pageSize: 50,
			total: 0,
			paginationkey: 0
		},
	}
	return obj
}
